import Quill from 'quill';
import { randomStr } from './utils';

export interface IImgValue {
  src: string;
  align?: 'left' | 'right' | 'center';
  width?: number;
  id: string;
}

const BlockEmbed = Quill.import('blots/block/embed');

class ImgBlot extends BlockEmbed {
  public static create(value: IImgValue) {
    const node = super.create(value) as HTMLImageElement;

    if (value.width) {
      node.width = value.width;
    }

    if (value.align) {
      node.align = value.align;
    }

    node.id = value.id || randomStr();
    node.setAttribute('src', value.src);

    return node;
  }

  public static register() {
    if (/Firefox/i.test(navigator.userAgent)) {
      setTimeout(() => {
        // Disable image resizing in Firefox
        document.execCommand('enableObjectResizing', false, undefined);
      }, 1);
    }
  }

  public static value(domNode: HTMLImageElement) {
    return {
      src: domNode.getAttribute('src'),
      width: domNode.width,
      align: domNode.align,
      id: domNode.id
    };
  }
}

ImgBlot.blotName = 'img';
ImgBlot.tagName = 'IMG';

export default ImgBlot;
